/* Affirm: "See if you qualify" opens Affirm's own modal. Publishable key only. */
_affirm_config = {
  public_api_key: "HLQX7D80TIYNPCPW",
  script: "https://cdn1.affirm.com/js/v2/affirm.js",
};
function installAffirm(l, g, m, e, a, f, b) {
  var d,
    c = l[m] || {},
    h = document.createElement(f),
    n = document.getElementsByTagName(f)[0],
    k = function (a, b, c) {
      return function () {
        a[b]._.push([c, arguments]);
      };
    };
  c[e] = k(c, e, "set");
  d = c[e];
  c[a] = {};
  c[a]._ = [];
  d._ = [];
  c[a][b] = k(c, a, b);
  a = 0;
  for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++)
    d[b[a]] = k(c, e, b[a]);
  a = 0;
  for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function () {};
  h.async = !0;
  h.src = g[f];
  n.parentNode.insertBefore(h, n);
  delete g[f];
  d(g);
  l[m] = c;
}

/* The Affirm CDN is large. Do not start it during first paint. Load it on idle,
   or on the first tap of the qualify line, whichever comes first. */
var affirmState = { ready: false, failed: false, stalled: false, pending: null };

function bootAffirm() {
  if (bootAffirm.started) return;
  bootAffirm.started = true;
  /* installAffirm deletes .script from the config once it has used it. */
  var src = _affirm_config.script;
  installAffirm(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
  /* Blocked or failed: the qualify line falls back to its plain link. */
  var script = document.querySelector('script[src="' + src + '"]');
  if (script) {
    script.addEventListener("error", function () {
      affirmState.failed = true;
      affirmState.pending = null;
    });
  }
  window.affirm.ui.ready(function () {
    affirmState.ready = true;
    if (affirmState.pending) {
      var queued = affirmState.pending;
      affirmState.pending = null;
      /* A cart redraw while waiting replaces the line: use the current one. */
      if (!queued.isConnected) {
        queued = document.querySelector('.affirm-qualify[data-page-type="' + queued.getAttribute("data-page-type") + '"]');
      }
      if (queued) affirmQualifyOpen(queued);
    }
    if (!window.affirm.events || typeof window.affirm.events.on !== "function") return;
    if (!affirmZoomIsIOS()) return;
    window.affirm.events.on("learnMore:open", function () { affirmZoomLock(); });
    window.affirm.events.on("prequal:open", function () { affirmZoomLock(); });
    /* Force unlock: close can fire while the iframe is still briefly in the DOM.
       Let Affirm finish tearing down before the viewport changes back. */
    window.affirm.events.on("learnMore:close", function () { affirmZoomRelease(); });
    window.affirm.events.on("prequal:close", function () { affirmZoomRelease(); });
  });
}

/* iOS zooms the page when an input under 16px takes focus, and Affirm's modal
   (cross-origin, so not ours to restyle) has one. maximum-scale=1 stops that
   zoom; since iOS 10 it no longer blocks pinch-zoom. Held only while a modal
   opened from the qualify line is up, and only on iOS WebKit.

   Changing the viewport meta makes iOS re-run text autosizing over the whole
   page. With text-size-adjust left on auto, the root (and so every rem) comes
   back larger after the modal closes and stays that way. Pin it to 100% before
   the first viewport change and leave it pinned for the rest of the page. */
var affirmZoom = { meta: null, original: null, added: [], observer: null, timer: 0, release: 0 };

function affirmZoomPinText() {
  var nodes = [document.documentElement, document.body];
  for (var i = 0; i < nodes.length; i++) {
    if (!nodes[i]) continue;
    nodes[i].style.setProperty("-webkit-text-size-adjust", "100%");
    nodes[i].style.setProperty("text-size-adjust", "100%");
  }
}

function affirmZoomIsIOS() {
  /* Discourse-style: iOS WebKit only (desktop Safari does not match apple-system-body). */
  return (
    typeof CSS !== "undefined" &&
    typeof CSS.supports === "function" &&
    CSS.supports("(font:-apple-system-body) and (-webkit-touch-callout:none)")
  );
}

function affirmZoomLock() {
  var meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  /* Reopened before a pending close-unlock ran: stay locked. */
  clearTimeout(affirmZoom.release);
  affirmZoomPinText();
  if (affirmZoom.original === null) {
    affirmZoom.meta = meta;
    affirmZoom.original = meta.getAttribute("content") || "";
    if (!/maximum-scale/.test(affirmZoom.original)) {
      meta.setAttribute("content", affirmZoom.original + ",maximum-scale=1");
    }
    /* Affirm hangs the modal off <body>. Note what arrives while locked, and
       unlock if that is taken away without a close event. */
    if (typeof MutationObserver === "function" && document.body) {
      affirmZoom.observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          mutations[i].addedNodes.forEach(function (node) {
            if (node.nodeType === 1) affirmZoom.added.push(node);
          });
        }
        if (!affirmZoom.added.length) return;
        clearTimeout(affirmZoom.timer);
        if (affirmZoomModalAlive()) return;
        affirmZoomUnlock();
      });
      affirmZoom.observer.observe(document.body, { childList: true });
    }
  }
  /* A tap that never opened a modal (or Affirm never mounted one). */
  clearTimeout(affirmZoom.timer);
  affirmZoom.timer = setTimeout(function () {
    if (!affirmZoomModalAlive()) affirmZoomUnlock();
  }, 8000);
}

/* A modal, not one of the hidden helper frames Affirm may also leave on <body>. */
function affirmZoomCovers(el) {
  if (!el || !el.isConnected || !el.getBoundingClientRect) return false;
  var rect = el.getBoundingClientRect();
  return rect.width * rect.height > 0.25 * window.innerWidth * window.innerHeight;
}

function affirmZoomModalAlive() {
  var frames = document.querySelectorAll('iframe[src*="affirm"]');
  for (var f = 0; f < frames.length; f++) {
    if (affirmZoomCovers(frames[f])) return true;
  }
  for (var i = 0; i < affirmZoom.added.length; i++) {
    if (affirmZoom.added[i].isConnected) return true;
  }
  return false;
}

function affirmZoomUnlock(force) {
  if (affirmZoom.original === null) return;
  /* Observer/timeout must not unlock while Affirm UI is still up. Close events force. */
  if (!force && affirmZoomModalAlive()) return;
  clearTimeout(affirmZoom.timer);
  clearTimeout(affirmZoom.release);
  if (affirmZoom.observer) affirmZoom.observer.disconnect();
  /* Still pinned, so the restore below cannot inflate anything. */
  affirmZoomPinText();
  affirmZoom.meta.setAttribute("content", affirmZoom.original);
  affirmZoom.meta = null;
  affirmZoom.original = null;
  affirmZoom.added = [];
  affirmZoom.observer = null;
  /* Lay the page out once more at the restored viewport. */
  void document.documentElement.offsetWidth;
}

/* Close event: unlock once Affirm has had a moment to remove its modal. */
function affirmZoomRelease() {
  clearTimeout(affirmZoom.release);
  affirmZoom.release = setTimeout(function () { affirmZoomUnlock(true); }, 50);
}

if (affirmZoomIsIOS()) {
  /* Capture, so the lock is in before Affirm's own handler opens the modal.
     touchstart and pointerdown come before click, which some open paths
     never deliver to us. */
  var affirmZoomOnTrigger = function (event) {
    /* Affirm failed to load: the tap follows the link, no modal to guard. */
    if (affirmState.failed) return;
    var target = event.target;
    if (target && target.closest && target.closest(".affirm-qualify")) {
      affirmZoomLock();
    }
  };
  ["touchstart", "pointerdown", "click"].forEach(function (type) {
    document.addEventListener(type, affirmZoomOnTrigger, { capture: true, passive: true });
  });

  /* Whatever opened it, an Affirm modal arriving on <body> takes the lock. */
  var affirmZoomWatchBody = function () {
    if (typeof MutationObserver !== "function" || !document.body) return;
    new MutationObserver(function (mutations) {
      if (affirmZoom.original !== null) return;
      var candidates = [];
      for (var i = 0; i < mutations.length; i++) {
        mutations[i].addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var frame = node.matches('iframe[src*="affirm"]') ? node : node.querySelector('iframe[src*="affirm"]');
          if (frame || /affirm/i.test((node.id || "") + " " + (node.getAttribute("class") || ""))) {
            candidates.push(frame || node);
          }
        });
      }
      if (!candidates.length) return;
      /* Measure after Affirm has styled it in. */
      requestAnimationFrame(function () {
        for (var j = 0; j < candidates.length; j++) {
          if (affirmZoomCovers(candidates[j])) {
            affirmZoomLock();
            return;
          }
        }
      });
    }).observe(document.body, { childList: true });
  };
  if (document.body) affirmZoomWatchBody();
  else document.addEventListener("DOMContentLoaded", affirmZoomWatchBody);
}

function scheduleAffirmBoot() {
  if (bootAffirm.started) return;
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(function () { bootAffirm(); }, { timeout: 2000 });
  } else {
    setTimeout(bootAffirm, 1);
  }
}

/* "See if you qualify" (snippets/affirm-qualify.liquid) opens Affirm's own
   modal for the amount on the line: the sticky bar's price on a product page,
   the cart total in the cart. data-amount is in cents and is read at open
   time, so it always matches what is on screen after a cart or bundle change.
   With an amount, Affirm shows its payment calculator when the key's promo
   config answers, and its general rates modal when it does not.

   The line is a link to Affirm's how-it-works page. That is what a tap does
   when Affirm's script was blocked or failed. Tapped before the script is
   ready, the modal opens once it is, and only once however often it was
   tapped. If Affirm is still not ready 6s after a tap, the queued tap is
   dropped and the next tap follows the link. */
function affirmQualifyOpen(trigger) {
  if (!window.affirm || !window.affirm.ui || typeof window.affirm.ui.openModal !== "function") return;
  var amount = parseInt(trigger.getAttribute("data-amount"), 10);
  var options = { pageType: trigger.getAttribute("data-page-type") || "product" };
  if (amount > 0) options.amount = amount;
  window.affirm.ui.openModal(options);
}

document.addEventListener("click", function (event) {
  var target = event.target;
  var trigger = target && target.closest ? target.closest(".affirm-qualify") : null;
  /* Blocked, or loaded but never ready: let the link open how-it-works. */
  if (!trigger || affirmState.failed || (affirmState.stalled && !affirmState.ready)) return;
  event.preventDefault();
  if (affirmState.ready) {
    affirmQualifyOpen(trigger);
    return;
  }
  affirmState.pending = trigger;
  bootAffirm();
  /* Affirm still not ready after 6s: drop the queued tap so it can't pop up
     late, and send the next tap to the link instead. */
  clearTimeout(affirmState.stallTimer);
  affirmState.stallTimer = setTimeout(function () {
    if (affirmState.ready) return;
    affirmState.pending = null;
    affirmState.stalled = true;
  }, 6000);
});

/* Kept for the cart and sticky-bar code that calls it after a change: the
   line carries its own amount, so all that is left is making sure Affirm is
   loading before the next tap. */
window.refreshAffirmMessaging = function () {
  bootAffirm();
};

scheduleAffirmBoot();
